import { ensureArray } from '~/utils';

export const useArray = <T>(input: MaybeRef<T[] | null | undefined>) => {
	const array = computed(() => ensureArray(unref(input)));
	return array;
};
